if (process.env.COLOR_MODEL_COVERAGE) {
  eval('module.exports = require("./.coverage/lib");');
} else {
  module.exports = require('./lib');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/color-model/index.js
// module id = XPbL
// module chunks = 11